module.exports = __webpack_public_path__ + "img/jackpot-bg.90c05cc4.png";